import getClusterResolutions from "../../../utils/get-cluster-resolutions";
import setPreviousInitials from "./set-previous-initials";

/**
 * Process pure value
 * @param {String} value
 * @param {MainClassProps} main
 * @param {StorageItemDataProps} data
 * @param {Map<String, any>} info
 */
const processPureValue = (value, main, data, info) => {
  const map = new Map();
  const resolutions = getClusterResolutions(value, 2);

  const path = info.get("path");
  const parent = info.get("parent");
  const fn = info.get("fn");
  const isNoneInitial = info.get("is-none-initial");

  /** Default property pure */
  map.set("is-coordinates-based", false);
  map.set("is-none-initial", isNoneInitial);
  map.set("is-parameter", false);
  map.set("is-option", false);
  map.set("is-value", true);
  map.set("parent-item", null);
  map.set("parent-item-data", info.get("fn-data"));
  map.set("original", value);
  map.set("resolutions", resolutions);
  map.set("path", path);
  map.set("property-data", data);
  map.set("parent", parent);
  map.set("fn", fn);
  map.set("v_is-calc", false);
  map.set("last-computed", "");

  /** Get the trigger if this property */
  const trigger = /** @type {TriggerMapProps} */ (data.get("trigger"));

  /** Get the storage map with all other flat values */
  const storage = /** @type {Array<any>} */ (main.storage.get("values"));

  /** Step of this property */
  const step = /** @type {StepProps} */ (data.get("step"));

  /** If trigger (means it is not an initial), add this "pure" value with its unique "path" into the step's "pure" set  */
  if (trigger) {
    const pure = /** @type {TriggerPureProps} */ (step?.get("pure"));
    const properties = /** @type {Map<String, any>} */ (data.get("properties"));

    pure.set(path, map);
    properties.get(parent).get(fn).get("pure").push(map);

    setPreviousInitials(trigger, step, map, path);
  }

  /** Add to the step's "flat" array */
  if (step.has("flat")) {
    /** Step "flat" array */
    const flat = /** @type {StepFlatProps} */ (step?.get("flat"));
    flat.push(map);
  }

  /** Add to the flat storage for further computation */
  storage?.push(map);

  return map;
};

export default processPureValue;
